import { RiskFieldsTypeEnum } from '@/__generated__/graphql';
import { RiskAssessmentDrawerTable } from '../RiskAssessmentDrawerTable';

export const POFValueTab = () => {
  const selectedTab = RiskFieldsTypeEnum.Pof;

  return <RiskAssessmentDrawerTable selectedTab={selectedTab} />;
};
